<div class="relative">
    <div class="bg-primary absolute -z-10 h-112 w-full" [class.hidden]="!hasPackageBlock()"></div>

    <div [class]="adLayoutClasses()" class="hidden justify-between gap-12">
        <packbo-dynamic-page
            class="w-full"
            [class]="hasPackageBlock() ? 'flex flex-wrap justify-around gap-4' : ''"
            [blocks]="nestedBlocks() | filterBlocks: 'content'"
        />
        <packbo-dynamic-page [blocks]="nestedBlocks() | filterBlocks: 'ads'" />
    </div>
</div>

<div class="flex flex-col px-4 md:px-20 lg:hidden" [class]="hasPackageBlock() ? 'flex flex-row justify-center' : ''">
    <packbo-dynamic-page [blocks]="nestedBlocks()" />
</div>
